import { MockUserFetch } from "__mock__/mock";
import { getUserSessionData, setUserSessionDataByKey } from "storage/userStorage";
import { getScid } from "./scid.js"
import { YES, CHINA, HKSAR, EEP, PASSPORT } from "referenceData/constants";
// 重新计时 timer out
export const rePrevious = () => {
    setUserSessionDataByKey('previous', Date.now());
}

export const throttle = (fn, delay) => {
    let previous = 0;
    return (params) => {
        const now = Date.now();
        if (now - previous > delay) {
            fn(params);
            previous = now;
        }
    }
}

// 复选框 -> 数组值
export const formatFormCheckboxArray = (checbox) => {
    if (JSON.stringify(checbox) === '{}') {
        return [];
    }
    const arrays = [];
    for (const key in checbox) {
        if (checbox[key]) {
            arrays.push(key);
        }
    }
    return arrays;
}

export const formatFormValueRequestBody = () => {
    const {
        global,
    } = getUserSessionData();

    return {
        applicationData: {
            productDetails: {
                productType: global.accountType,                                      // 账户类型 HSBC One /HSBC Premier  **(原accountType)**
            },
            customerLanguage: global.lang,
            accountUsage: getAccountUsage()
        },
        applicant: {
            personalDetails: getPersonalDetails(),
            contactDetails: getContactDetails(),
            employmentDetails: getEmploymentDetails(),
            financialDetails: getFinancialDetails(),
        },
        preferences: getPreferences(),
        deviceDetails: {
            behaviouralSessionIdentifier: getScid() // TMX SDK scid
        }
    }
}

function getPersonalDetails() {
    const {
        personal: {
            firstName,
            lastName,
            fullName,
            gender,
            title,
            nationality,
            nationality2,
            nationality3,
            prcIdNumber,
            chineseLegalName,
            dateOfBirth,
            documentType,
            placeOfIssue,
            dateOfExpiry,
            permitNumber,
            countryOfBirth
        },
        financial: {
            residentialReason,
            correspondenceReason,
            residentialReasonOther,
            explainResidenceReasonText,
        },
        declaration: {
            preferredChannels,
            additionalDeclarationConsent,
            ackTncIndicator,
        }
    } = getUserSessionData();

    const customerNames = () => {
        return [
            {
                nameType: "LOCAL", // 姓名类型 [PRIMARY-拼音, LOCAL-中文,  ALIAS-拼音曾用名1, ALIAS_LOCAL-中文曾用名1]
                firstName, // 名 len: 35
                lastName,  // 姓 len: 35
                fullName,  // 全名 len:70
                chineseName: nationality === CHINA ? chineseLegalName : '',
            }
        ];
    }

    return {
        customerNames: customerNames(),
        gender,
        title,
        dateOfBirth: new Date(dateOfBirth),
        nationalityDetails: {              // 国籍(国家/地区)
            nationality,                   // 第一国籍(国家/地区) [CN, US, JP, GB, ...]
            nationality2: nationality2,    // 第二国籍(国家/地区) [CN, US, JP, GB, ...]
            nationality3: nationality3,    // 第三国籍(国家/地区) [CN, US, JP, GB, ...]
            chineseIdNumber: nationality === CHINA ? prcIdNumber : '',
        },
        customerNRCIndicator: nationality === CHINA && additionalDeclarationConsent === true && [EEP, PASSPORT].includes(documentType),
        ackTncIndicator: ackTncIndicator === true,
        consentOfCepFlag: preferredChannels.length > 0,
        identificationDocument: {
            documentType: documentType,
            placeOfIssue: placeOfIssue,
            proofDocumentExpireDate: dateOfExpiry,
            documentReference: permitNumber //出入境许可证号码
        },
        countryOfBirth: countryOfBirth,
        ...(residentialReason && { reasonForNoTaxInfoInResidencialAddressCountry: residentialReason }),
        ...(correspondenceReason && { reasonForNoTaxInfoInCorrespondenceAddressCountry: correspondenceReason }),
        ...(residentialReason === 'E' && residentialReasonOther?.trim() && {
            explainTaxResidenceReasonText: residentialReasonOther.trim()
        }),
        ...(correspondenceReason === 'E' && explainResidenceReasonText?.trim() && {
            explainResidenceReasonText: explainResidenceReasonText.trim()
        })
    };
}

function getContactDetails() {
    const {
        personal: {
            email,
            phoneNumber: {
                raw,
                extendedValues
            } = {}
        },
        address: {
            currentResidentialAddress,
            correspondenceAddressDifferent,
            correspondenceAddress,
            cartAddress,
            atmCountry,
        },
    } = getUserSessionData();

    // addresses
    currentResidentialAddress.addressType = 'RESIDENTIAL_ADDRESS';
    currentResidentialAddress.addressLine3 = currentResidentialAddress.addressLine3 || currentResidentialAddress.districtCode;

    const addresses = [currentResidentialAddress];

    if (correspondenceAddressDifferent === 'no') {
        const corrAddress = correspondenceAddress || {};
        corrAddress.addressType = 'CORRESPONDENCE_ADDRESS';
        corrAddress.addressLine3 = corrAddress.addressLine3 || corrAddress.districtCode;
        addresses.push(corrAddress);
    }

    if (cartAddress === '2') {
        addresses.push({
            addressType: 'DELIVERY_ADDRESS',
            addressLine3: atmCountry
        });
    }

    return {
        telephoneNumbers: [{
            number: raw,
            countryCode: extendedValues?.countryCallingCode
        }],
        emailAddressList: [{
            emailAddress: email
        }],
        addresses
    }
}

function getEmploymentDetails() {
    const {
        financial: {
            employmentStatus,
            employmentRole,
            occupation,
            industry,
            employerName,
            addressCountry,
            paidFromEmployerIndicator,
        },
    } = getUserSessionData();

    const employmentDetails = {
        employmentStatus,
        employmentRole,
        occupation,
        employerName,
        industry: industry?.value || '',
        employerAddress: { addressCountry },
        paidFromEmployerIndicator: paidFromEmployerIndicator === YES,
    };

    return employmentDetails;
}

function getFinancialDetails() {
    const {
        financial: {
            gross,
            additionalNationalities
        },
    } = getUserSessionData();

    // 客户经济状况
    const grossIncome = {};
    //客户月收入总额
    if (gross) {
        grossIncome.amount = gross;
        grossIncome.currency = 'HKD'
    }

    const taxResidencyInfo = {};
    const taxResidencyDetails = [];
    additionalNationalities.forEach(item => {
        if (item.countryOfTaxResidency && item.agree) {
            taxResidencyDetails.push({
                countryOfTaxResidency: item.countryOfTaxResidency,
                reasonForNoTIN: item.reasonForNoTIN,
                explainForNotEligibleApply: item.explainForNotEligibleApply,
            })
        }
        if (item.countryOfTaxResidency && !item.agree) {
            taxResidencyDetails.push({
                countryOfTaxResidency: item.countryOfTaxResidency,
                reasonForNoTIN: item.reasonForNoTIN,
                taxDocumentIdNumber: item.taxDocumentIdNumber,
                explainForNotEligibleApply: item.explainForNotEligibleApply,
            })
        }
    })
    taxResidencyDetails.forEach(item => {
        if (item.reasonForNoTIN === 'EXPLANATION1' || item.reasonForNoTIN === 'EXPLANATION2') {
            item.explanationForNoTIN = item.reasonForNoTIN
            item.reasonForNoTIN = 'REASON3'
        }
    })
    taxResidencyInfo.taxResidencyDetails = taxResidencyDetails;

    return {
        grossIncome,
        taxResidencyInfo
    }
}

function getFundsDetails(detailsObj, isFirstDeposit, sourceSame) {
    // special logic for first deposit section
    const isSourceSame = sourceSame === YES;
    const firstDepositSame = isFirstDeposit ? { firstDepositSameAsRegularFundsSource: isSourceSame } : {};
    if (isSourceSame) {
        return firstDepositSame;
    }

    // common logic
    const { fundsSource, depositSource, anotherSource, otherNationality, depositAmount } = detailsObj;
    const fundsDetails = {
        sourceCategoryCode: fundsSource,
        initialFundsSourceList: depositSource,
        initialFundsSourceRemark: anotherSource,
        fundsOriginationCountry: otherNationality,
        initialDepositAmount: depositAmount ? { currency: 'HKD', amount: depositAmount } : null,
        ...firstDepositSame,
    };

    return fundsDetails;
}

function getAccountUsage() {
    const {
        address: {
            currentResidentialAddress: {
                addressCountry
            },
            selectReasonsForOpeningAccount,
            otherReasonForOpeningAccountInAnotherCountryText
        },
        financial: { paidFromEmployerIndicator },
        using: {
            selectAccountPurpose,
            regularFundsDetailsObj,
            sourceSame,
            firstDepositDetailsObj
        }
    } = getUserSessionData();

    return {
        accountPurpose: selectAccountPurpose || [],
        regularFundsDetails: paidFromEmployerIndicator === YES ? {} : getFundsDetails(regularFundsDetailsObj, false, ''),
        firstDepositDetails: getFundsDetails(firstDepositDetailsObj, true, sourceSame),
        ...(addressCountry === HKSAR ? {} : {
            reasonForOpeningAccountInAnotherCountry: selectReasonsForOpeningAccount
        }),
        ...(selectReasonsForOpeningAccount === 'SOMETHING_ELSE' ? {
            otherReasonForOpeningAccountInAnotherCountryText
        } : null),
    };
}

function setRelationshipWithHSBC(current3, relative2, relative3, relative4) {
    if (current3 !== 'yes') {
        return {
            hasRelationship: relative2.one ? '1' : '2'
        };
    }

    const hasUnsecuredAmount = `${relative4 || ''}`.trim() !== '';

    return {
        ...(relative2.one ? { staffNo: relative3 } : {}),
        ...(hasUnsecuredAmount ? {
            totalAmountOfUnsecured: {
                amount: relative4,                                                                     // 数值
                currency: "HKD"                                                                        // 币种 [CNY, HKD, USD, ...] Hardcode HKD in FE is need
            }
        } : {}),
        hasRelationship: relative2.one ? '1' : '2'
    }
}

function setRelationshipDetails(current3, relative, relative1, relative2) {
    if (current3 !== 'yes' || !relative2.two) {
        return {};
    }

    return {
        relatives: [{
            relationship: relative1,
            fullname: relative
        }]
    }
}

// Credit Card
function getPreferences() {
    const {
        global,
        address: {
            cartAddress
        },
        declaration: { preferredChannels },
        creditCard: {
            isApplyCreditCard,
            creditCardType,
            statementPreferencesOptions,
            grpTermsAndConditions,
            settlment,
            settlmentValue,
            facillity,
            facillityValue,
            balanceValue,
            accounat,
            current3,
            relative,
            relative1,
            relative2,
            relative3,
            relative4
        }
    } = getUserSessionData();

    const debitCardPreferences = {
        deliveryAddressType: cartAddress
    }

    const relationshipDetails = setRelationshipDetails(current3, relative, relative1, relative2);
    relationshipDetails.relationshipWithHSBC = setRelationshipWithHSBC(current3, relative2, relative3, relative4);

    const creditCardData = {
        isAppliedCreditCard: isApplyCreditCard === 'yes' ? '1' : '2',
        creditCardType: creditCardType,                                        // [Visa Signature, HSBC Premier MasterCard]
        usingFreeATPOrEPSFacility: facillity === 'yes' ? '1' : '2',
        directDebitInstruction: settlment === 'yes' ? '1' : '2',              // [1: required, 2: not required]
        outOfLimitFacility: accounat === 'yes' ? '1' : '2',
        ...(settlment === 'yes' && { debitAccount: settlmentValue }),
        ...(settlmentValue && { amountOfMonthlyPayment: facillityValue !== '% of statement balance' ? '1' : '2' }),   // [1: Minimum payment due, 2: Monthly payment]
        ...(facillityValue === '% of statement balance' && { percentageOfMonthlyPayment: balanceValue }),
        relationshipDetails,
        statementPreferencesOptions,
        grpTermsAndConditions
    };

    // HSBC Premier
    const enableCreditCard = global.accountType === 'HSBC Premier' && global.enableCreditCard;
    return {
        ...(enableCreditCard && { creditCardPreference: creditCardData }),
        marketingPreferences: {
            preferredChannels: !preferredChannels.length ? ['NO_NEED'] : preferredChannels
        },
        debitCardPreferences,

    };
}


export const userFetch = (url = process.env.submitApi) => {
    /* NOSONAR */
    if (process.env.MOCK === 'on') {
        if (sessionStorage.getItem('dummy') === 'on') {
            return MockUserFetch();
        }
    }

    return fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formatFormValueRequestBody())
    }).then(response => {
        if (!response.ok) {
            throw new Error(`Fetch failed with status: ${response.status}`);
        }
        const headers = new Headers();
        headers.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
        return new Response(response.body, {
            status: response.status,
            statusText: response.statusText,
            headers: headers
        });
    }).then(async (responseWithSTS) => {

        const result = await responseWithSTS.json();
        if (responseWithSTS.ok) {
            return result;
        }
    }).catch(() => {
        throw new Error('Network response was not ok.');
    });
}
